import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={26.669}
    height={26.293}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 708109 698144"
    {...props}
  >
    <defs>
      <style>
        {
          ".str0{stroke:#2b2a29;stroke-width:20070.8}.fil1{fill:#2b2a29;fill-rule:nonzero}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974325545312">
        <path
          d="M357632 498218c16639-22580 92015-100103 113691-117013 50207 58276-13879 163317-113691 117013zm-90158 48832-58768-139462 168064-171876c40352 3271 102371 37492 147801 50498-40091 46444-85321 86485-127189 129698-32083 33127-98477 108824-129908 131142zM107901 35144l47527-251-682 191165-45440 522-1405-191436zm84588 350457C161058 353497 59861 265989 43935 235049l38094-39740 2218 49435c27618 10447 65150 7797 93480 2679 3753-33478 2158-67980 1776-101739-752-67819-592-39228 23172-77634 21817 11882 140817 129477 157064 150200L192489 385601zM86104 16829c-10136 37523 8259 101940-6142 138971-8088 20763-53639 48973-68361 79249 36037 51753 106436 116933 146065 154445 65893 62401 60925 159423 103435 195009 27086-7848 57383-47548 76440-68422 54964 18355 94724 38034 143938-9654 59891-58055 16037-130189 9253-150350 19820-13619 61647-52415 69876-78829-58004-38746-138087-36679-196052-94533-31099-31030-124168-128273-154414-145845l-8972 4315c-873 562-3101 1736-4165 2469l-11039 8922c-963 822-2739 2589-3502 3271-753 682-2138 2429-3442 3352l-1225-44417c-20251-5188-24827-4435-44105-4737l-47588 6784z"
          className="fill"
          style={{
            fill: "#2b2a29",
          }}
        />
        <path
          d="m517205 529549 176804 140375-11209 14120-176804-140386zM554286 432205l105823 84017-11209 14120-105824-84027zM415115 560578l105823 84027-11219 14089-105814-84016z"
          className="fil1"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
